export default "__VITE_ASSET__C0S$S$54__"